module.exports = __webpack_public_path__ + "static/media/recruit-01.434aec74.png";